import { isDate } from 'date-fns';
/** Returns true if `value` is a Date type. */
export function isDateType(value) {
    return isDate(value);
}
//# sourceMappingURL=isDateType.js.map